import React from 'react';
import { TextInput } from 'react-admin';

const SwishProductInformation = () => (
  <TextInput source="productInformation.phoneNumber" label="Swish phone number" />
);

export default SwishProductInformation;
